@if (showItem) {
  <div class="card">
    <!-- Countdown Timer -->
    <div class="detail">
      <div class="unstaking-time">
        {{ "unstaking_time_left" | translate }}
      </div>
      <div class="timer">
        {{ unstackingData?.releaseTimeStamp | countdown_custom_format | async }}
      </div>
    </div>
    <!-- Progress Bar -->
    @if (progress$ | async; as progress) {
      <div class="progress">
        <bp-progress-indicator [value]="progress"> </bp-progress-indicator>
      </div>
    }
    <!-- Payout Detail -->
    <div class="payout">
      <!-- Payout Sum -->
      <div class="detail">
        <div>
          {{ "payout" | translate }}
        </div>
        <div class="sum">
          <div class="fiat">
            {{
            unstackingData?.fiatAmount
            | fiat_precision_symbol
            : {
            id: defaultFiat?.getId(),
            currencies: [defaultFiat],
            symbol: true,
            prefix: unstackingData.fiatAmount < 0.01,
            tradableAmount: +unstackingData.assetAmount
          }
          }}
        </div>
        <div class="asset">
          {{
          unstackingData?.assetAmount
          | tradable_precision_symbol
          : {
          id: unstackingData?.assetId,
          addName: true,
          noTrailingZeros: true
        }
        }}
      </div>
    </div>
  </div>
  <!-- Date -->
  <div class="detail payout-date">
    <div>
      {{ "unstaking_payout_date" | translate }}
    </div>
    <div class="date">
      <bp-badge variant="ghost" size="small">
        <bp-icon size="16" icon="calendar-clock" theme="regular"></bp-icon>
      </bp-badge>
      <div>
        {{
        unstackingData?.releaseTimeStamp
        | bp_date: { time: [], day: "DD", month: "MMM", year: "YYYY", dateSeperator: " " }
        }}
      </div>
    </div>
  </div>
</div>
</div>
}
